import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqItemsService } from '../services/constructionBoqItems.service';
import type { ConstructionBoqItem } from '../types/construction-boq.types';

export function useConstructionBoqItems(boqId?: string) {
  const itemsQuery = useQuery({
    queryKey: ['construction-boqs', 'items', boqId],
    queryFn: () => ConstructionBoqItemsService.getBoqItems(boqId!),
    enabled: !!boqId,
  });

  const statsQuery = useQuery({
    queryKey: ['construction-boqs', 'stats', boqId],
    queryFn: () => ConstructionBoqItemsService.getBoqStats(boqId!),
    enabled: !!boqId,
  });

  const queryClient = useQueryClient();

  const updateItemMutation = useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: Partial<ConstructionBoqItem> }) =>
      ConstructionBoqItemsService.updateBoqItem(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'items', boqId] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'stats', boqId] });
    },
  });

  return {
    items: itemsQuery.data || [],
    stats: statsQuery.data,
    isLoading: itemsQuery.isLoading || statsQuery.isLoading,
    updateItem: updateItemMutation.mutateAsync,
  };
}
